<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
  props: {
    animate: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<template>
  <content-loader
    width="1276"
    height="241"
    viewBox="0 0 1276 241"
    :speed="animate ? 2 : 0"
    primaryColor="#F9FAFF"
    secondaryColor="#D8DFF6"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <path d="M161 151H1234" stroke-width="2" />
    <path d="M162 147V155" stroke-width="2" />
    <path d="M1233 147V155" stroke-width="2" />
    <circle cx="204.5" cy="135.5" r="8" stroke="white" />
    <circle cx="204.5" cy="135.5" r="8" stroke="white" />
    <circle cx="197.5" cy="151.5" r="8" stroke="white" />
    <circle cx="228.5" cy="136.5" r="8" stroke="white" />
    <circle cx="219.5" cy="150.5" r="8" stroke="white" />
    <circle cx="248.5" cy="136.5" r="8" stroke="white" />
    <circle cx="240.5" cy="150.5" r="8" stroke="white" />
    <circle cx="268.5" cy="135.5" r="8" stroke="white" />
    <circle cx="271.5" cy="151.5" r="8" stroke="white" />
    <circle cx="288.5" cy="135.5" r="8" stroke="white" />
    <circle cx="303.5" cy="119.5" r="8" stroke="white" />
    <circle cx="306.5" cy="136.5" r="8" stroke="white" />
    <circle cx="298.5" cy="150.5" r="8" stroke="white" />
    <circle cx="290.5" cy="165.5" r="8" stroke="white" />
    <circle cx="307.5" cy="164.5" r="8" stroke="white" />
    <circle cx="316.5" cy="150.5" r="8" stroke="white" />
    <circle cx="323.5" cy="135.5" r="8" stroke="white" />
    <circle cx="330.5" cy="120.5" r="8" stroke="white" />
    <circle cx="341.5" cy="134.5" r="8" stroke="white" />
    <circle cx="333.5" cy="148.5" r="8" stroke="white" />
    <circle cx="325.5" cy="163.5" r="8" stroke="white" />
    <circle cx="358.5" cy="127.5" r="8" stroke="white" />
    <circle cx="360.5" cy="143.5" r="8" stroke="white" />
    <circle cx="367.5" cy="159.5" r="8" stroke="white" />
    <circle cx="392.5" cy="129.5" r="8" stroke="white" />
    <circle cx="409.5" cy="133.5" r="8" stroke="white" />
    <circle cx="388.5" cy="145.5" r="8" stroke="white" />
    <circle cx="407.5" cy="149.5" r="8" stroke="white" />
    <circle cx="395.5" cy="161.5" r="8" stroke="white" />
    <circle cx="433.5" cy="152.5" r="8" stroke="white" />
    <circle cx="434.5" cy="134.5" r="8" stroke="white" />
    <circle cx="460.5" cy="143.5" r="8" stroke="white" />
    <circle cx="491.5" cy="150.5" r="8" stroke="white" />
    <circle cx="501.5" cy="137.5" r="8" stroke="white" />
    <circle cx="525.5" cy="137.5" r="8" stroke="white" />
    <circle cx="535.5" cy="150.5" r="8" stroke="white" />
    <circle cx="556.5" cy="139.5" r="8" stroke="white" />
    <circle cx="572.5" cy="147.5" r="8" stroke="white" />
    <circle cx="573.5" cy="131.5" r="8" stroke="white" />
    <circle cx="558.5" cy="156.5" r="8" stroke="white" />
    <circle cx="624.5" cy="135.5" r="8" stroke="white" />
    <circle cx="626.5" cy="151.5" r="8" stroke="white" />
    <circle cx="667.5" cy="145.5" r="8" stroke="white" />
    <circle cx="680.5" cy="135.5" r="8" stroke="white" />
    <circle cx="691.5" cy="148.5" r="8" stroke="white" />
    <circle cx="698.5" cy="164.5" r="8" stroke="white" />
    <circle cx="705.5" cy="140.5" r="8" stroke="white" />
    <circle cx="703.5" cy="122.5" r="8" stroke="white" />
    <circle cx="720.5" cy="151.5" r="8" stroke="white" />
    <circle cx="783.5" cy="143.5" r="8" stroke="white" />
    <circle cx="802.5" cy="136.5" r="8" stroke="white" />
    <circle cx="809.5" cy="151.5" r="8" stroke="white" />
    <circle cx="850.5" cy="134.5" r="8" stroke="white" />
    <circle cx="851.5" cy="153.5" r="8" stroke="white" />
    <circle cx="868.5" cy="143.5" r="8" stroke="white" />
    <circle cx="887.5" cy="152.5" r="8" stroke="white" />
    <circle cx="887.5" cy="135.5" r="8" stroke="white" />
    <circle cx="977.5" cy="138.5" r="8" stroke="white" />
    <circle cx="999.5" cy="140.5" r="8" stroke="white" />
    <circle cx="1184.5" cy="143.5" r="8" stroke="white" />
    <circle cx="1215.5" cy="135.5" r="8" stroke="white" />
    <circle cx="1220.5" cy="151.5" r="8" stroke="white" />
    <circle cx="989.5" cy="152.5" r="8" stroke="white" />
    <circle cx="754.5" cy="143.5" r="8" stroke="white" />
    <rect x="53" y="122" width="79" height="51" rx="6" />
    <rect x="43" y="22" width="209" height="30" rx="6" />
  </content-loader>
</template>
